import {Component, HostBinding, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {AsideService, AsidePosition} from '../../../core/services/aside.service';
import {AsideSection} from '../../../shared/models/aside/interfaces';
import {SessionService} from '../../../core/services/session.service';
import {User} from '../../../shared/models/user';
import {AppsService} from '../../../core/services/apps.service';
import {AlarmsService} from '../../../core/services/alarms.service';
import {OptionGroup} from '../../../shared/models/option';
import {ConnectedPosition} from '@angular/cdk/overlay';
import {PopoverMenuComponent} from '../../components/popover-menu/popover-menu.component';
import {NgClass} from '@angular/common';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {ShareButtonComponent} from '../../components/share-button/share-button.component';
import {UserAvatarComponent} from '../../../shared/components/user-avatar/user-avatar.component';

@Component({
  selector: 'motn-page-aside',
  templateUrl: './page-aside.component.html',
  styleUrls: ['./page-aside.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PopoverMenuComponent,
    NgClass,
    RouterLink,
    RouterLinkActive,
    ShareButtonComponent,
    UserAvatarComponent,
  ],
})
export class PageAsideComponent implements OnInit {
  asidePosition: AsidePosition;
  allSections: AsideSection[] = [];
  /**
   * Usually unchanging sections that apply no matter where you're at
   * in the platform.
   */
  private globalSections: AsideSection[] = [];
  /**
   * Sections that are populated based on the current app/view.
   */
  private contextSections: AsideSection[] = [];

  alarmIconColor: 'red' | 'yellow' | '' = '';

  userMenuOpen: boolean = false;
  userMenuTitle: string;
  currentUser: User | null = null;

  @HostBinding('class.popover-open')
  get hasOpenPopover(): boolean {
    return this.userMenuOpen;
  }


  get userMenuOptions(): OptionGroup {
    const og = new OptionGroup([
      {
        id: 'profile',
        name: 'My Profile',
        href: '/profile',
      },
      {
        id: 'security',
        name: 'Security',
        href: '/security',
      },
      {
        id: 'logout',
        name: 'Log Out',
        callback: () => {
          this.session.logOut();
        },
      },
    ]);

    if (this.session.isUserAdmin()) {
      og.options.splice(2, 0, {
        id: 'admin',
        name: 'Admin Tools',
        href: '/admin-tools',
      });
    }

    return og;
  }


  overlayPositions: ConnectedPosition[] = [{
    originX: 'center',
    originY: 'bottom',
    overlayX: 'center',
    overlayY: 'top',
  }];


  constructor(
    private appsService: AppsService,
    private asideService: AsideService,
    private alarmsService: AlarmsService,
    private session: SessionService,
  ) {
  }


  ngOnInit(): void {
    this.session.user$.subscribe({
      next: (user) => {
        this.currentUser = user;
        if (user) {
          this.userMenuTitle =  user.Name || user.Username || 'User';
        }
      },
    });

    this.asideService.getGlobalSections$().subscribe(
      (sections) => {
        this.globalSections = sections;
        this.combineSections();
      },
    );

    this.asideService.getContextSections$().subscribe(
      (sections) => {
        this.contextSections = sections;
        this.combineSections();
      },
    );

    this.asideService.asidePosition$.subscribe(
      (position) => {
        if (position) {
          this.asidePosition = position;
          this.combineSections();
        }
      },
    );

    this.alarmsService.activeEvents$.subscribe(
      (alarmEvents) => {
        let highestLevel: 'red' | 'yellow' | '' = '';

        for (let alarmEvent of alarmEvents) {
          highestLevel = 'yellow';

          if (!alarmEvent.AckTime) {
            highestLevel = 'red';
            break;
          }
        }

        this.alarmIconColor = highestLevel;
      },
    );

    this.appsService.fetchUserApps$().subscribe();
  }




  private combineSections() {
    this.allSections = [
      ...this.globalSections,
      ...this.contextSections,
    ];
  }


  toggleAsideFixed() {
    this.asideService.toggleFixed();
  }
}
